import { updateBookingSettings } from "@/api/providerDashboard";

export default {
  save() {
    clearTimeout(this.saveTimeout);
    this.saveTimeout = setTimeout(() => this.doSave(), 500);
  },
  async doSave() {
    try {
      await updateBookingSettings({
        onlineBookingEnabled: this.onlineBookingEnabled,
        bookingSettings: {
          businessHours: this.businessHours,
          bookingInterval: this.bookingInterval,
          maxConcurrentBookings: this.maxConcurrent,
          holidays: this.holidays,
        },
      });
      this.$message.success("저장되었습니다.");
    } catch (err) {
      this.$alert("저장 실패");
    }
  },
};
